import getConfig from 'next/config';
import { CoreVisitorGlobalHeader } from '@care/navigation';
import { Grid } from '@mui/material';
import { Error404 } from '@care/react-pages';
import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { NextConfig } from '@/interfaces';
import { HomepageFooter } from './homepage/variant1/Layout';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';

const { publicRuntimeConfig } = getConfig() as NextConfig;

const { CORE_BASE_URL } = publicRuntimeConfig;

const Custom404 = () => {
  const { flags } = useFeatureFlags();
  const logoUrl =
    flags[CLIENT_FEATURE_FLAGS.TTP_ASSET_URL]?.value ?? `${CORE_BASE_URL}/s/d/ttp/care-logo.svg`;

  return (
    <Grid container>
      <Grid item xs={12}>
        <CoreVisitorGlobalHeader altLogoUrl={logoUrl} />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          paddingX: 9,
          paddingY: 3,
        }}>
        <Error404 prev="/" />
      </Grid>
      <Grid item xs={12}>
        <HomepageFooter />
      </Grid>
    </Grid>
  );
};

export default Custom404;
